// One11 YMM fitment selector. Calls the Render backend directly (CORS), not via
// Shopify's app proxy. Every fetch is wrapped in try/catch so a failure resets
// the dropdown instead of hanging on "Loading...".

(function () {
  function init(root) {
    if (root.dataset.ymmInit) return; // avoid double-init when >1 selector on page
    root.dataset.ymmInit = '1';
    const yearSel = root.querySelector('[data-ymm-year]');
    const makeSel = root.querySelector('[data-ymm-make]');
    const modelSel = root.querySelector('[data-ymm-model]');
    const submit = root.querySelector('[data-ymm-submit]');
    const vinInput = root.querySelector('[data-ymm-vin]');
    const vinBtn = root.querySelector('[data-ymm-vin-submit]');
    if (!yearSel) return;

    const opt = (label, value) => `<option value="${value == null ? '' : value}">${label}</option>`;

    function setOptions(sel, placeholder, values) {
      sel.innerHTML = opt(placeholder, '');
      for (const v of values) sel.innerHTML += opt(v, v);
      sel.disabled = values.length === 0;
    }

    async function getJSON(url) {
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }

    // Populate years from the backend (falls back to a sane range if it fails)
    (async () => {
      try {
        const data = await getJSON('https://one11-performance.onrender.com/apps/turn14?endpoint=years');
        const years = (data.years && data.years.length) ? data.years
          : defaultYears();
        setOptions(yearSel, 'Year', years);
      } catch (e) {
        setOptions(yearSel, 'Year', defaultYears());
      }
    })();

    function defaultYears() {
      const out = [];
      for (let y = 2026; y >= 1990; y--) out.push(y);
      return out;
    }

    yearSel.addEventListener('change', async () => {
      setOptions(makeSel, 'Make', []);
      setOptions(modelSel, 'Model', []);
      if (!yearSel.value) return;
      makeSel.innerHTML = opt('Loading...', '');
      try {
        const data = await getJSON('https://one11-performance.onrender.com/apps/turn14?endpoint=makes&year=' + encodeURIComponent(yearSel.value));
        setOptions(makeSel, 'Make', data.makes || []);
      } catch (e) {
        setOptions(makeSel, 'Make', []); // reset, never hang
      }
    });

    makeSel.addEventListener('change', async () => {
      setOptions(modelSel, 'Model', []);
      if (!makeSel.value) return;
      modelSel.innerHTML = opt('Loading...', '');
      try {
        const url = 'https://one11-performance.onrender.com/apps/turn14?endpoint=models&year=' + encodeURIComponent(yearSel.value) +
          '&make=' + encodeURIComponent(makeSel.value);
        const data = await getJSON(url);
        setOptions(modelSel, 'Model', data.models || []);
      } catch (e) {
        setOptions(modelSel, 'Model', []);
      }
    });

    function goToResults(year, make, model) {
      const p = new URLSearchParams();
      if (year) p.set('year', year);
      if (make) p.set('make', make);
      if (model) p.set('model', model);
      // results rendered by the fitment-results page template (backend-served)
      window.location.href = '/pages/find-parts?' + p.toString();
    }

    submit && submit.addEventListener('click', () => {
      if (!yearSel.value || !makeSel.value) {
        alert('Please select at least Year and Make');
        return;
      }
      goToResults(yearSel.value, makeSel.value, modelSel.value);
    });

    // VIN lookup via NHTSA vPIC (free, public)
    vinBtn && vinBtn.addEventListener('click', async () => {
      const vin = (vinInput.value || '').trim();
      if (!vin) { alert('Please enter a VIN'); return; }
      const label = vinBtn.textContent;
      vinBtn.textContent = 'Decoding...';
      try {
        const data = await getJSON('https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/' + encodeURIComponent(vin) + '?format=json');
        const get = (name) => (data.Results.find((r) => r.Variable === name) || {}).Value;
        const year = get('Model Year'), make = get('Make'), model = get('Model');
        if (year && make) goToResults(year, titleCase(make), model ? titleCase(model) : '');
        else alert('VIN could not be decoded');
      } catch (e) {
        alert('VIN lookup failed, please try again');
      } finally {
        vinBtn.textContent = label;
      }
    });

    function titleCase(s) {
      return String(s).toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ymm]').forEach(init);
  });
})();
